import Api from 'api'

const config = {
  baseURL: '/api/app/v1/accounts-marketplace',
}

const api = new Api(config)

api.fetchProducts = ({ ...rest }) => api.get('/products', { ...rest })

api.fetchProductById = ({ id, ...rest }) =>
  api.get(`/products/${id}`, { ...rest })

api.fetchCategories = ({ ...rest }) => api.get('/categories', { ...rest })

api.createOrder = ({ ...rest }) => api.post('/orders', { ...rest })

api.fetchOrders = ({ ...rest }) => api.get('/orders/items', { ...rest })

api.fetchOrderItemById = ({ id, ...rest }) =>
  api.get(`/orders/items/${id}`, { ...rest })

export default api
